import { render, staticRenderFns } from "./SubgrupoField.vue?vue&type=template&id=d42a9288&scoped=true&"
import script from "./SubgrupoField.vue?vue&type=script&lang=js&"
export * from "./SubgrupoField.vue?vue&type=script&lang=js&"
import style0 from "./SubgrupoField.vue?vue&type=style&index=0&id=d42a9288&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d42a9288",
  null
  
)

export default component.exports